// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"472": "BusinessProVisitorLazyComponent","787": "BadgeTooltipV1",}[chunkId] + "." + {"472": "6dc254a17f66abd8","787": "7a9decf519d7e12e",}[chunkId] + ".js"
}